import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

// format 참고 - https://day.js.org/docs/en/durations/format
export const sec2time = (seconds: number, format: string) =>
  dayjs.duration(seconds * 1000).format(format)

export const getCourseTotalTime = (totalSeconds: number) => {
  const [M, D, h, m] = sec2time(totalSeconds, 'M:D:H:m').split(':')
  let hour = 0
  if (Number(M) > 0) {
    hour = hour + Number(M) * 30 * 24
  }

  if (Number(D) > 0) {
    hour = Number(D) * 24 + hour
  }

  hour = hour + Number(h)

  return Number(m) === 0 ? `${hour}시간` : `${hour}시간 ${m}분`
}
